import { SsoActionTypes } from '../actions/sso';
const initialState = {
  allowedIdps: []
};
export default function sso(state = initialState, action) {
  switch (action.type) {
    case SsoActionTypes.SET_SSO_DATA:
      return Object.assign({}, state, action.payload);
    case SsoActionTypes.RESET_STATE:
      return initialState;
    default:
      return state;
  }
}